import { Injectable, Injector } from '@angular/core';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { AtestadoModeloModel } from '../models';

@Injectable({
  providedIn: 'root'
})
export class AtestadoService extends BaseCrudService<AtestadoModeloModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'AtestadoModelo';
  }
}
